"use strict";
exports.placeholderChar = '_';



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/forms/mask/constants.js
// module id = 55
// module chunks = 0